import React from "react";

export type LayoutPortalState = {
  /**
   * Container for left side of the AppBar
   */
  leftContainer: React.RefObject<HTMLDivElement>;

  /**
   * Container for right side of the AppBar
   */
  rightContainer: React.RefObject<HTMLDivElement>;

  /**
   * Container for the global banner under the AppBar
   */
  bannerContainer: React.RefObject<HTMLDivElement>;

  /**
   * Flag to indicate if FPS #999 mode is enabled. Just for testing - remove it later
   */
  isFpsLimitExceeded: boolean;

  /**
   * Toggle the FPS #999 mode. Just for testing - remove it later
   */
  setIsFpsLimitExceeded: (value: boolean) => void;
};

export const LayoutPortalContext = React.createContext<
  LayoutPortalState | undefined
>(undefined);

export default LayoutPortalContext;
